import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const updateOrgProfile = async (payload) => {
    try {
        let { status } = await axios.put(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization/${payload.id}/users/`, payload);
        return status
    } catch (err) {
        console.log("error while creating organization", err.message);
        addNotification({
          title: "Techforce.ai",
          message: "Update profile has been failed",
          type: "danger"
        });
    }
}